import { useState } from 'react';
import Icon from './Icons';
import Revelar from './Revelar';
import servicos from '../data/servicos';
import { site, linkWhatsApp } from '../config';
import './Contato.css';

const inicial = {
  nome: '',
  telefone: '',
  email: '',
  assunto: '',
  mensagem: '',
  consentimento: false,
};

function validar(dados) {
  const erros = {};

  if (dados.nome.trim().length < 3) {
    erros.nome = 'Informe o seu nome completo.';
  }

  const digitos = dados.telefone.replace(/\D/g, '');
  if (digitos.length < 10 || digitos.length > 13) {
    erros.telefone = 'Informe um telefone válido com DDD.';
  }

  if (dados.email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(dados.email)) {
    erros.email = 'Informe um e-mail válido ou deixe o campo em branco.';
  }

  if (dados.mensagem.trim().length < 15) {
    erros.mensagem = 'Descreva o caso com um pouco mais de detalhe.';
  }

  if (!dados.consentimento) {
    erros.consentimento = 'É necessário concordar para prosseguir.';
  }

  return erros;
}

/** Aplica a máscara (11) 91234-5678 conforme o usuário digita. */
function mascararTelefone(valor) {
  const d = valor.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export default function Contato({ cabecalho = true }) {
  const [dados, setDados] = useState(inicial);
  const [erros, setErros] = useState({});
  const [enviado, setEnviado] = useState(false);

  const aoMudar = (evento) => {
    const { name, value, type, checked } = evento.target;
    const novoValor =
      type === 'checkbox' ? checked : name === 'telefone' ? mascararTelefone(value) : value;

    setDados((atual) => ({ ...atual, [name]: novoValor }));
    setErros((atual) => ({ ...atual, [name]: undefined }));
  };

  const aoEnviar = (evento) => {
    evento.preventDefault();

    const novosErros = validar(dados);
    setErros(novosErros);
    if (Object.keys(novosErros).length > 0) return;

    const texto = [
      'Olá, vim pelo site.',
      '',
      `Nome: ${dados.nome}`,
      `Telefone: ${dados.telefone}`,
      dados.email ? `E-mail: ${dados.email}` : null,
      dados.assunto ? `Assunto: ${dados.assunto}` : null,
      '',
      dados.mensagem,
    ]
      .filter(Boolean)
      .join('\n');

    window.open(linkWhatsApp(texto), '_blank', 'noopener,noreferrer');
    setEnviado(true);
    setDados(inicial);
  };

  const contatos = [
    {
      icone: 'whatsapp',
      titulo: 'WhatsApp',
      valor: site.celular,
      href: linkWhatsApp(),
      externo: true,
    },
    { icone: 'telefone', titulo: 'Telefone', valor: site.telefone, href: `tel:${site.telefoneLink}` },
    { icone: 'email', titulo: 'E-mail', valor: site.email, href: `mailto:${site.email}` },
    // Não há escritório aberto ao público: declaramos a praça de atuação e
    // como o atendimento acontece, em vez de um endereço que não existe.
    {
      icone: 'local',
      titulo: 'Atendimento',
      valor: `${site.atuacao.presencial}. ${site.atuacao.remoto}.`,
    },
    { icone: 'relogio', titulo: 'Horário', valor: `${site.horario} · ${site.plantao}` },
  ];

  return (
    <section className="secao secao--escura" id="contato">
      <div className="container">
        {/* A página /contato traz o próprio cabeçalho, com H1 — aqui ele é
            suprimido para não haver dois títulos dizendo a mesma coisa. */}
        {cabecalho && (
          <div className="cabecalho-secao">
            <span className="rotulo">Contato</span>
            <h2 className="titulo-secao">Fale com o advogado</h2>
            <p className="subtitulo-secao">
              Descreva a sua situação com o máximo de informação possível. O
              retorno costuma acontecer no mesmo dia útil — casos urgentes têm
              prioridade.
            </p>
          </div>
        )}

        <div className="contato__grade">
          <Revelar className="contato__form-area">
            <form className="formulario" onSubmit={aoEnviar} noValidate>
              <div className="formulario__linha">
                <div className="campo">
                  <label htmlFor="nome">Nome completo *</label>
                  <input
                    id="nome"
                    name="nome"
                    type="text"
                    value={dados.nome}
                    onChange={aoMudar}
                    autoComplete="name"
                    aria-invalid={Boolean(erros.nome)}
                    aria-describedby={erros.nome ? 'erro-nome' : undefined}
                  />
                  {erros.nome && (
                    <span className="campo__erro" id="erro-nome">
                      {erros.nome}
                    </span>
                  )}
                </div>

                <div className="campo">
                  <label htmlFor="telefone">Telefone / WhatsApp *</label>
                  <input
                    id="telefone"
                    name="telefone"
                    type="tel"
                    inputMode="tel"
                    placeholder="(11) 90000-0000"
                    value={dados.telefone}
                    onChange={aoMudar}
                    autoComplete="tel"
                    aria-invalid={Boolean(erros.telefone)}
                    aria-describedby={erros.telefone ? 'erro-telefone' : undefined}
                  />
                  {erros.telefone && (
                    <span className="campo__erro" id="erro-telefone">
                      {erros.telefone}
                    </span>
                  )}
                </div>
              </div>

              <div className="formulario__linha">
                <div className="campo">
                  <label htmlFor="email">E-mail</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={dados.email}
                    onChange={aoMudar}
                    autoComplete="email"
                    aria-invalid={Boolean(erros.email)}
                    aria-describedby={erros.email ? 'erro-email' : undefined}
                  />
                  {erros.email && (
                    <span className="campo__erro" id="erro-email">
                      {erros.email}
                    </span>
                  )}
                </div>

                <div className="campo">
                  <label htmlFor="assunto">Assunto</label>
                  <select id="assunto" name="assunto" value={dados.assunto} onChange={aoMudar}>
                    <option value="">Selecione uma área</option>
                    {servicos.map((servico) => (
                      <option key={servico.id} value={servico.titulo}>
                        {servico.titulo}
                      </option>
                    ))}
                    <option value="Outro assunto">Outro assunto</option>
                  </select>
                </div>
              </div>

              <div className="campo">
                <label htmlFor="mensagem">Descreva a situação *</label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  rows="5"
                  value={dados.mensagem}
                  onChange={aoMudar}
                  placeholder="Conte o que aconteceu, em que fase está o caso e se há prazo ou audiência marcada."
                  aria-invalid={Boolean(erros.mensagem)}
                  aria-describedby={erros.mensagem ? 'erro-mensagem' : undefined}
                />
                {erros.mensagem && (
                  <span className="campo__erro" id="erro-mensagem">
                    {erros.mensagem}
                  </span>
                )}
              </div>

              <label className="consentimento">
                <input
                  type="checkbox"
                  name="consentimento"
                  checked={dados.consentimento}
                  onChange={aoMudar}
                  aria-describedby={erros.consentimento ? 'erro-consentimento' : undefined}
                />
                <span>
                  Autorizo o uso dos dados informados exclusivamente para
                  responder a este contato, nos termos da Lei nº 13.709/2018
                  (LGPD).
                </span>
              </label>
              {erros.consentimento && (
                <span className="campo__erro" id="erro-consentimento">
                  {erros.consentimento}
                </span>
              )}

              <button type="submit" className="btn btn--ouro btn--bloco">
                <Icon name="whatsapp" size={18} />
                Enviar pelo WhatsApp
              </button>

              {enviado && (
                <p className="formulario__sucesso" role="status">
                  <Icon name="check" size={18} />
                  Mensagem preparada. Se a janela do WhatsApp não abrir,
                  verifique o bloqueador de pop-ups ou escreva para{' '}
                  <a href={`mailto:${site.email}`}>{site.email}</a>.
                </p>
              )}

              <p className="formulario__nota">
                O envio deste formulário não cria, por si só, relação entre
                advogado e cliente. Evite enviar documentos sigilosos antes do
                primeiro contato.
              </p>
            </form>
          </Revelar>

          <Revelar className="contato__dados" atraso={120}>
            <ul className="contatos">
              {contatos.map((item) => {
                const conteudo = (
                  <>
                    <span className="contatos__icone">
                      <Icon name={item.icone} size={20} />
                    </span>
                    <span>
                      <strong>{item.titulo}</strong>
                      <span>{item.valor}</span>
                    </span>
                  </>
                );

                return (
                  <li key={item.titulo}>
                    {item.href ? (
                      <a
                        href={item.href}
                        {...(item.externo
                          ? { target: '_blank', rel: 'noopener noreferrer' }
                          : {})}
                      >
                        {conteudo}
                      </a>
                    ) : (
                      <div>{conteudo}</div>
                    )}
                  </li>
                );
              })}
            </ul>

            {(site.instagram || site.linkedin) && (
              <div className="contato__redes">
                <span>Acompanhe</span>
                {site.instagram && (
                  <a
                    href={site.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <Icon name="instagram" size={20} />
                  </a>
                )}
                {site.linkedin && (
                  <a
                    href={site.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <Icon name="linkedin" size={20} />
                  </a>
                )}
              </div>
            )}
          </Revelar>
        </div>
      </div>
    </section>
  );
}
